import {
  IMG_HOSTNAME,
  SUPPORTED_DOMAINS_NAMES,
  DOMAIN_NAME
} from '@/configs/dybr';

const domainsPattern = SUPPORTED_DOMAINS_NAMES.map(d =>
  d.replace(/\./g, '\\.')
).join('|');
const regex = new RegExp(`^(https?:)?\\/\\/([^/]*\\.)?(${domainsPattern})`);

export function getRelativeUrl(url) {
  // TODO: debug why there's sometimes an object coming for background url
  if (typeof url !== 'string') return '';
  const devPrefix = IMG_HOSTNAME === undefined ? '' : IMG_HOSTNAME;
  return devPrefix + url.replace(regex, '');
}

export function replaceDybrHostname(url) {
  return replaceHostname(url, SUPPORTED_DOMAINS_NAMES, DOMAIN_NAME);
}

export function replaceDiaryHostname(url) {
  return replaceHostname(url, ['diary.ru', 'diary.space'], 'diarybackup.space');
}

function replaceHostname(url, fromDomains, toDomain) {
  if (typeof url !== 'string') return url;

  const domainsPattern = fromDomains
    .map(d => d.replace(/\./g, '\\.'))
    .join('|');
  const domainRegex = new RegExp(
    `^(https?:)?\\/\\/([^/]*\\.)?(${domainsPattern})`,
    'i'
  );

  if (domainRegex.test(url)) {
    return url.replace(domainRegex, `https://$2${toDomain}`);
  }
  return url;
}
